var FeatureFlagSetting;
(function (FeatureFlagSetting) {
    FeatureFlagSetting["NONE"] = "none";
    FeatureFlagSetting["TRUE"] = "true";
    FeatureFlagSetting["FALSE"] = "false";
})(FeatureFlagSetting || (FeatureFlagSetting = {}));
const featureFlagSettings = [
    FeatureFlagSetting.NONE,
    FeatureFlagSetting.TRUE,
    FeatureFlagSetting.FALSE,
];
const rawSettingToFeatureFlagSetting = (rawSetting) => {
    if (rawSetting === undefined)
        return FeatureFlagSetting.NONE;
    return rawSetting ? FeatureFlagSetting.TRUE : FeatureFlagSetting.FALSE;
};

export { FeatureFlagSetting, featureFlagSettings, rawSettingToFeatureFlagSetting };
